import { setLaunchState } from './actions'
import { setupListeners } from './listeners'
import StoreSelectorComponent from './components/StoreSelectorComponent.svelte'
import Backdrop from './components/Backdrop.svelte'
import { mount } from 'svelte'

export const instantiate = (config) => {
  const wrapper = document.createElement('div')
  wrapper.setAttribute('id', 'store-selector-app')
  wrapper.setAttribute('role', 'dialog')
  wrapper.setAttribute('aria-modal', true)
  document.body.appendChild(wrapper)

  const backdropInstance = mount(Backdrop, { target: document.body })

  setupListeners()
  setLaunchState(config)
  const selectorInstance = mount(StoreSelectorComponent, { target: wrapper })

  return { selectorInstance, backdropInstance }
}
